import React, { useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { getInloInfo } from "../common/commonMethod";
import {
  getToday,
  getMonthByDate,
  exportRowsToExcel,
} from "../common/commonMethod";
import {
  DataGrid,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { columns5_6 } from "./helper/UI_5_6.helper";
import axios from "axios";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const CHK_ITEM_CD = [
  "",
  "latency",
  "datacnt",
  "ping",
  "http",
  "cpu",
  "memory",
  "disk",
];

/*관리자 > 감시이력조회*/
export const UI_5_6 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo), user);
  const [rows, setRows] = React.useState([]);
  const [columns, setColumns] = useState(columns5_6);
  const [pageSize, setPageSize] = useState(25);
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };
  const [fetchMonTarget, setFetchMonTarget] = useState([]);
  const [fetchChkItemCd, setFetchChkItemCd] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    monTargetNm: "all",
    chkItemCd: "all",
    startDate: getMonthByDate(-3),
    endDate: getToday(),
  });

  useEffect(() => {
    getMonTargetFilter();
    submitBtnClick();
  }, [inlo, user]);

  const getMonTargetFilter = async () => {
    try {
      const response = await axios.get(`/api/vup/select_5_5`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      const result = response?.data;
      setFetchMonTarget(result);

      // 초기 체크 항목 목록 생성 (전체 서버의 Y인 항목들)
      const checkItems = [];
      if (result && result.length > 0) {
        const allCheckItems = new Set();
        result.forEach((server) => {
          Object.entries(server).forEach(([key, value]) => {
            if (
              key.startsWith("use") &&
              key.endsWith("ChkYn") &&
              value === "Y"
            ) {
              allCheckItems.add(key);
            }
          });
        });

        allCheckItems.forEach((key) => {
          const itemName = key
            .replace("use", "")
            .replace("ChkYn", "")
            .toLowerCase();
          checkItems.push({
            chkItemCd: key,
            chkItemNm: itemName,
          });
        });
      }
      setFetchChkItemCd(checkItems);
    } catch (e) {
      console.log("UI_5_6 fetchData error", e);
    }
  };

  const submitBtnClick = async () => {
    if (selectedFilter == null) return;

    try {
      const uri = "vup/select_5_6";
      const chkItemCdIndex = CHK_ITEM_CD.indexOf(
        selectedFilter.chkItemCd
          .replace("use", "")
          .replace("ChkYn", "")
          .toLowerCase()
      );
      const param = {
        startDate: selectedFilter.startDate.replace(/-/gi, ""),
        endDate: selectedFilter.endDate.replace(/-/gi, ""),
        monTargetNo: selectedFilter.monTargetNo,
        chkItemCd: chkItemCdIndex,
      };
      const res = await FxmsData.selectGridData(uri, param);

      let index = 0;
      for (let data of res.data) {
        data.id = index++;
      }
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      let response = res.data;
      response.map((item, index) => {
        return { ...item, id: index };
      });

      // 그리드에 데이터
      setRows(response);
      //  제외할 키 목록
      const excludedKeys = new Set([
        "id",
        "chkRstCd",
        "regUserNo",
        "chgDtm",
        "chkItemCd",
        "monLogId",
        "alertSentYn",
        "baseThrVal",
        "measVal",
        "monTargetNo",
        "monTargetNm",
        "chgUserNo",
        "regDtm",
        "checkDtm",
        "cdName",
        "recipients",
      ]);

      let result = response.flatMap((obj) => {
        // 필터링된 키들을 담을 배열
        const filteredKeys = [];

        // 기존 객체의 모든 키를 순회합니다.
        for (let key in obj) {
          // 제외할 키가 아니라면 배열에 추가합니다.
          if (!excludedKeys.has(key)) {
            filteredKeys.push({
              field: key,
              headerName: key,
              width: 120,
              headerClassName: "DataGridHeader",
              valueFormatter: (params) => {
                return new Intl.NumberFormat("ko-KR").format(params.value);
              },
            });
          }
        }

        //키 정렬
        filteredKeys.sort((a, b) => (a.field > b.field ? 1 : -1));
        return filteredKeys;
      });
      // 중복 제거
      result = Array.from(
        new Map(result.map((item) => [item.field, item])).values()
      );
      setColumns((prev) => [...columns5_6, ...result]);
    } catch (e) {
      console.log("UI_5_6 fetchData error", e);
    }
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer sx={{ float: "right" }} />
    );
  };

  // DataGrid columns -> MuiTable용 2차원 배열 변환 함수 추가
  const makeMuiTableHeader = (columns) => [
    columns
      .filter(col => col.field !== "id") // id 컬럼 제외
      .map(col => ({
        cellName: col.headerName,
        id: col.headerName,
        row: 1,
        col: 1,
        style: { width: col.width ? `${col.width}px` : undefined }
      }))
  ];

  const exportToExcel = () => {
    // renderCell 우선 적용이 필요하다면 exportRowsToExcel 함수 내에서 우선순위 확장 필요
    exportRowsToExcel({
      columns,
      rows,
      fileName: props.menuFullName || "tableData",
      sheetName: (props.menuFullName || "downloadData").replaceAll("/", "_"),
      excludeId: true
    });
  };

  const onChangeFilter = (event) => {
    const { value, name } = event.target;
    resetFilterFrom(name);

    if (name === "monTargetNo") {
      if (value === "all") {
        // 서버 전체 선택 시 모든 가능한 항목 표시
        const allCheckItems = new Set();
        fetchMonTarget.forEach((server) => {
          Object.entries(server).forEach(([key, value]) => {
            if (
              key.startsWith("use") &&
              key.endsWith("ChkYn") &&
              value === "Y"
            ) {
              allCheckItems.add(key);
            }
          });
        });

        const checkItems = Array.from(allCheckItems).map((key) => ({
          chkItemCd: key,
          chkItemNm: key.replace("use", "").replace("ChkYn", "").toLowerCase(),
        }));
        setFetchChkItemCd(checkItems);
      } else {
        // 특정 서버 선택 시 해당 서버의 Y인 항목만 표시
        const selectedServer = fetchMonTarget.find(
          (item) => item.monTargetNo === Number(value)
        );
        if (selectedServer) {
          const checkItems = [];
          Object.entries(selectedServer).forEach(([key, value]) => {
            if (
              key.startsWith("use") &&
              key.endsWith("ChkYn") &&
              value === "Y"
            ) {
              const itemName = key
                .replace("use", "")
                .replace("ChkYn", "")
                .toLowerCase();
              checkItems.push({
                chkItemCd: key,
                chkItemNm: itemName,
              });
            }
          });
          setFetchChkItemCd(checkItems);
        }
      }
    }

    setSelectedFilter((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilterFrom = (fieldName) => {};

  return (
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>
          <select
            className="FxSelectSearch"
            name="monTargetNo"
            onChange={onChangeFilter}
          >
            <option value="all">서버 전체</option>
            {fetchMonTarget?.map((item) => (
              <option
                key={item.monTargetNo}
                value={item.monTargetNo}
                name="monTargetNm"
              >
                {item.monTargetNm}
              </option>
            ))}
          </select>
          <label className="FxLabelSearch"></label>
          <select
            className="FxSelectSearch"
            name="chkItemCd"
            onChange={onChangeFilter}
          >
            <option value="all">항목 전체</option>
            {fetchChkItemCd?.map((item) => (
              <option key={item.chkItemCd} value={item.chkItemCd}>
                {item.chkItemNm}
              </option>
            ))}
          </select>
        </div>
        <div className="FxFilterRight">
          <input
            className="FxDate"
            type="date"
            name="startDate"
            value={selectedFilter.startDate}
            onChange={onChangeFilter}
          />
          <label className="FxLabelSearch">~</label>
          <input
            className="FxDate"
            type="date"
            name="endDate"
            value={selectedFilter.endDate}
            onChange={onChangeFilter}
          />
          <input
            className="FxButtonSearch"
            type="button"
            value="조회"
            onClick={submitBtnClick}
          />
        </div>
      </div>
      <div className="FxCrudDataGrid">
        <div class="FxDataTitle">감시 이력</div>
        <div className="excelDown">
          <Button onClick={exportToExcel} startIcon={<FileDownloadIcon />}>
            엑셀 다운로드
          </Button>
        </div>
        <Box className="DataGridList" sx={{ height: "430px", width: "100%" }}>
          <DataGrid
            className="DataGrid"
            cellClassName="DataGridCell"
            rowHeight={36}
            rows={rows}
            columns={columns}
            components={{ Toolbar: CustomToolbar }}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            rowsPerPageOptions={[25, 50, 100]}
            // onRowClick={handleOnClickRow}
          ></DataGrid>
        </Box>
      </div>
    </div>
  );
};
